import React, { Children, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import IconButton from '../icon-button';

import MinusCircled from './assets/minusCircled.svg?react';
import PlusCircled from './assets/plusCircled.svg?react';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${(props) => props.theme.colors['surface-white']};
    border-left: 8px solid ${(props) => (props.sideFlagColor ? props.theme.colors[props.sideFlagColor] : 'transparent')};
    box-shadow: ${(props) => props.theme.shadows['shadow-02dp']};
    border-radius: 4px;
`;

export const Header = styled.div`
    display: flex;
    flex-grow: 1;
    justify-content: space-between;
    padding: 4px 8px;
    cursor: pointer;
`;

const HeaderContent = styled.div`
    flex-grow: 1;
    align-self: center;
`;

export const Body = styled.div`
    padding: 8px;
`;

/**
 * Accordion accepts 2 children. The first is the content of the header,
 * the second is the body shown when the accordion is opened.
 * @param {*} param0
 */
const Accordion = ({ children, CloseIcon = MinusCircled, OpenIcon = PlusCircled, sideFlagColor, defaultOpened = false }) => {
    const [opened, setOpened] = useState(defaultOpened);
    const [header, body] = Children.toArray(children);

    const changeState = () => {
        setOpened((oldValue) => !oldValue);
    };

    return (
        <Container sideFlagColor={sideFlagColor}>
            <Header onClick={changeState}>
                <HeaderContent>{header}</HeaderContent>
                <IconButton type="tertiary" size="xsmall">
                    {opened ? <CloseIcon /> : <OpenIcon />}
                </IconButton>
            </Header>
            {opened && <Body>{body}</Body>}
        </Container>
    );
};

Accordion.propTypes = {
    children: PropTypes.node.isRequired,
    CloseIcon: PropTypes.object,
    OpenIcon: PropTypes.object,
    defaultOpened: PropTypes.bool,
    sideFlagColor: PropTypes.string,
};

export default Accordion;
